import Marquee from "react-fast-marquee";
export const CoinSlider = ({ data }) => {
  return (
    <Marquee className="marquee" pauseOnHover={true}>
      {data?.map((item, index) => (
        <a
          href={`/trade/${item.base}-${item.quote}`}
          key={index}
          className="marquee-item"
        >
          {item.base}/{item.quote}
          <span className={item.change_in_price > 0 ? "up" : "down"}>
            {item.change_in_price.toFixed(2)}%
          </span>
        </a>
      ))}
    </Marquee>
  );
};
